module.exports = __webpack_public_path__ + "img/sara-ava.a32bedc.png";